import { useState } from 'react';
import { useAtom } from 'jotai';
import styled from 'styled-components';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { Balloon, selectedDeviceAtom } from './MapView';

import type { Device } from '@/@types/device';

interface Props {
  device: Device;
}

const CustomMarker = styled(AdvancedMarker)`
  height: 48px;
  &.focused {
    height: 64px;
  }

  img {
    width: 48px;
    height: 48px;
  }
  img.focused {
    width: 64px;
    height: 64px;
  }
`;

export default function MapMarker({ device }: Props) {
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useAtom(selectedDeviceAtom);

  const isSelected = selectedDevice?.serialNumber === device.serialNumber;
  const isFocusedClass = infoWindowOpen || isSelected ? 'focused' : '';
  const zIndex = infoWindowOpen ? 1000 : isSelected ? 999 : null;

  function onClick() {
    setSelectedDevice(device);
  }
  function onMouseEnter() {
    if (isSelected) return;
    setInfoWindowOpen(true);
  }
  function onMouseLeave() {
    setInfoWindowOpen(false);
  }

  return (
    <>
      <CustomMarker
        className={isFocusedClass}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        position={{ lat: device.data.latitude, lng: device.data.longitude }}
        title="AdvancedMarker that opens an Infowindow when clicked."
        zIndex={zIndex}
      >
        <img src={`/images/map/pin-${device.status}.svg`} className={isFocusedClass} alt={device.status} />
        {infoWindowOpen && (
          <Balloon className={device.status}>
            {device.name}
            <br />
            {device.serialNumber}
          </Balloon>
        )}
      </CustomMarker>
    </>
  );
}
